import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { FilterSelectDetailPage } from './filter-select-detail.page';

const routes: Routes = [
  {
    path: '',
    component: FilterSelectDetailPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [FilterSelectDetailPage]
})
export class FilterSelectDetailPageModule {}
